import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, NOTES } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	ParkNumber = "parkNumber",
	Aliases = "aliases",
	Brand = "brand",
	Model = "model",
	RegistrationNumber = "registrationNumber",
	Color = "color",
	Class = "class",
	BodyType = "bodyType",
	RegisteredAt = "registeredAt",
	CarParkId = "carParkId",
	ResponsibleDispatcher = "responsibleDispatcher",
	Company = "company",
	TaxiService = "taxiService",
	ElectronicReceipts = "electronicReceipts",
	Notes = "notes",
}

export const translationTablePath = "mainPage.accounts.transport.columns.";

const accountsTransport = makeTable({
	allIds: [
		ColumnId.ParkNumber,
		ColumnId.Aliases,
		ColumnId.Brand,
		ColumnId.Model,
		ColumnId.RegistrationNumber,
		ColumnId.Color,
		ColumnId.Class,
		ColumnId.BodyType,
		ColumnId.RegisteredAt,
		ColumnId.CarParkId,
		ColumnId.ResponsibleDispatcher,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.ElectronicReceipts,
		ColumnId.Notes,
	],
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: [
		ColumnId.ParkNumber,
		ColumnId.Aliases,
		ColumnId.Brand,
		ColumnId.Model,
		ColumnId.RegistrationNumber,
		ColumnId.Color,
		ColumnId.Class,
		ColumnId.BodyType,
		ColumnId.RegisteredAt,
		ColumnId.CarParkId,
		ColumnId.ResponsibleDispatcher,
		ColumnId.Company,
		ColumnId.TaxiService,
		ColumnId.ElectronicReceipts,
		ColumnId.Notes,
	],
	initialSortMethod: {
		column: ColumnId.ParkNumber,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.ParkNumber]: 160,
		[ColumnId.Aliases]: 120,
		[ColumnId.Brand]: 100,
		[ColumnId.Model]: 100,
		[ColumnId.RegistrationNumber]: 150,
		[ColumnId.Color]: 100,
		[ColumnId.Class]: 100,
		[ColumnId.BodyType]: 150,
		[ColumnId.RegisteredAt]: DATE,
		[ColumnId.CarParkId]: 150,
		[ColumnId.ResponsibleDispatcher]: 150,
		[ColumnId.Company]: 120,
		[ColumnId.TaxiService]: 120,
		[ColumnId.ElectronicReceipts]: 180,
		[ColumnId.Notes]: NOTES,
	},
	initialResizable: {
		[ColumnId.ParkNumber]: true,
		[ColumnId.Aliases]: true,
		[ColumnId.Brand]: true,
		[ColumnId.Model]: true,
		[ColumnId.RegistrationNumber]: true,
		[ColumnId.Color]: true,
		[ColumnId.Class]: true,
		[ColumnId.BodyType]: true,
		[ColumnId.RegisteredAt]: true,
		[ColumnId.CarParkId]: true,
		[ColumnId.ResponsibleDispatcher]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.ElectronicReceipts]: true,
		[ColumnId.Notes]: true,
	},
	initialSortable: {
		[ColumnId.ParkNumber]: true,
		[ColumnId.Aliases]: true,
		[ColumnId.Brand]: true,
		[ColumnId.Model]: true,
		[ColumnId.RegistrationNumber]: true,
		[ColumnId.Color]: true,
		[ColumnId.Class]: true,
		[ColumnId.BodyType]: true,
		[ColumnId.RegisteredAt]: true,
		[ColumnId.CarParkId]: true,
		[ColumnId.ResponsibleDispatcher]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
		[ColumnId.ElectronicReceipts]: true,
		[ColumnId.Notes]: true,
	},
});

export default accountsTransport;
